import { getVariantKeyAttributes } from "entities/products/lib/getProductType"

export type WildcardMode = "full" | "partial" | "none"

export interface VariantKeyCompareResult {
  matchedCount: number
  ranges1: number[]
  ranges2: number[]
}

function indicesToRanges(attrs: string[], indices: number[]): number[] {
  const offsets = attrs.reduce<number[]>(
    (acc, attr) => [...acc, acc[acc.length - 1] + attr.length + 1],
    [0]
  )
  const ranges: number[] = []
  // eslint-disable-next-line no-restricted-syntax
  for (const index of indices) {
    const start = offsets[index]
    const end = start + attrs[index].length
    if (ranges.length > 0 && ranges[ranges.length - 1] === offsets[index] - 1) {
      ranges[ranges.length - 1] = end
    } else {
      ranges.push(start, end)
    }
  }
  return ranges
}

export function compareVariantKeys(
  key1: string,
  key2: string,
  options?: { wildcardMode?: WildcardMode }
): VariantKeyCompareResult | null {
  const wildcardMode = options?.wildcardMode ?? "partial"
  const attrs1 = getVariantKeyAttributes(key1)
  const attrs2 = getVariantKeyAttributes(key2)

  let matchedCount = 0
  const rangeIndices: number[] = []

  for (let i = 0; i < Math.min(attrs1.length, attrs2.length); i += 1) {
    const a = attrs1[i]
    const b = attrs2[i]
    const isWildcard = a === "*" || b === "*"

    if (isWildcard) {
      if (wildcardMode === "none") return null
      if (wildcardMode === "full") {
        matchedCount += 1
        rangeIndices.push(i)
      }
    } else if (a !== b) {
      return null
    } else {
      matchedCount += 1
      rangeIndices.push(i)
    }
  }

  return {
    matchedCount,
    ranges1: indicesToRanges(attrs1, rangeIndices),
    ranges2: indicesToRanges(attrs2, rangeIndices)
  }
}
